import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import { IProfile, IProfileResponse } from '../types'

export const fetchProfile = async () => {
  const resp = await axios.get<IProfileResponse>(`${window.apiEndpoint}/me`)
  return convertCaseList(resp.data, ConvertType.CAMEL) as IProfile
}

export const useProfileQuery = () => {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => fetchProfile(),
  })
}
